import React, {useEffect, useState} from "react";
import axios from 'axios';
import {API_URL} from "../../../utils/Common";

const CantPorColor = (props) => {
    const { cantidad, porId } = props;

    const [valor, setValor] = useState(0);

    useEffect(() => {
        setValor(cantidad);
    }, [cantidad]);

    const onChange = (e) => {
        setValor(e.target.value === ''?0:e.target.value);
        updatePorColor(e.target.value);
    }

    const updatePorColor = (cantidad) => {
        axios.post(API_URL + '/setPorColor', { porId, cantidad })
            .then(r => console.log(r.data))
            .catch(e => console.log(e));
    }

    return (
        <input className={valor > 0?"mt-1 text-xs text-right appearance-none block w-20 bg-orange-200 text-gray-700 border border-orange-200 rounded py-3 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500":
            "text-xs text-right appearance-none block w-20 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"}
               type="number"
               step="any"
               name="cantidad"
               value={valor}
               onChange={onChange}/>
    )
}

export default CantPorColor;
